module.exports = __webpack_public_path__ + "img/pago-efectivo.ca6ea112.png";